import { render, staticRenderFns } from "./PendingPaymentsSuperadmin.vue?vue&type=template&id=cd9501f6"
import script from "./PendingPaymentsSuperadmin.vue?vue&type=script&lang=js"
export * from "./PendingPaymentsSuperadmin.vue?vue&type=script&lang=js"
import style0 from "./PendingPaymentsSuperadmin.vue?vue&type=style&index=0&id=cd9501f6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports